import { Card } from '@sainsburys-tech/luna-card'
import {
  Title,
  ReferenceNumber,
  ReportedByDescription,
  EnforcementContactDescription
} from '../Components'
import { IEnforcementContact } from '../../../types'

const EnforcementContactCard = ({ enforcementContact }: IEnforcementContact) => {
  return (
    <Card
      className="s-reported-enforcement-contacts-card rln-c-card ln-c-card--soft ln-u-margin-bottom*2 ln-u-margin-left"
    >
      <Title text={enforcementContact.category} />
      <ReferenceNumber referenceNumber={enforcementContact.reference} />
      <EnforcementContactDescription
        contactDateTime={enforcementContact.contactDateTime}
        store={enforcementContact.store}
      />
      <ReportedByDescription
        reportedBy={enforcementContact.reportedBy}
        dateReported={enforcementContact.dateReported}
      />
    </Card>
  )
}

export default EnforcementContactCard
